import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

function MateriaisMetodos() {
  const [activeTab, setActiveTab] = useState('materiais');
  const [materiais, setMateriais] = useState([]);
  const [metodos, setMetodos] = useState([]);
  const [loadingMateriais, setLoadingMateriais] = useState(true);
  const [loadingMetodos, setLoadingMetodos] = useState(true);
  const [searchMateriais, setSearchMateriais] = useState('');
  const [searchMetodos, setSearchMetodos] = useState('');

  useEffect(() => {
    fetchMateriais();
    fetchMetodos();
  }, []);

  const fetchMateriais = async () => {
    setLoadingMateriais(true);
    try {
      const response = await axios.get(`${API_URL}/materiais`);
      setMateriais(response.data.data || response.data || []);
    } catch (err) {
      console.error('Erro ao buscar materiais:', err);
      setMateriais([]);
    } finally {
      setLoadingMateriais(false);
    }
  };

  const fetchMetodos = async () => {
    setLoadingMetodos(true);
    try {
      const response = await axios.get(`${API_URL}/metodos`);
      setMetodos(response.data.data || response.data || []);
    } catch (err) {
      console.error('Erro ao buscar métodos:', err);
      setMetodos([]);
    } finally {
      setLoadingMetodos(false);
    }
  };

  const filteredMateriais = materiais.filter(item =>
    (item.DESCRICAO || '').toLowerCase().includes(searchMateriais.toLowerCase())
  );

  const filteredMetodos = metodos.filter(item =>
    (item.DESCRICAO || '').toLowerCase().includes(searchMetodos.toLowerCase())
  );

  const styles = {
    container: {
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
    },
    pageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '12px',
    },
    pageIcon: {
      fontSize: '1.5rem',
      lineHeight: 1,
    },
    pageTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1a1a2e',
      margin: '0 0 2px 0',
    },
    pageSubtitle: {
      fontSize: '0.85rem',
      color: '#666',
      margin: 0,
    },
    card: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      overflow: 'hidden',
    },
    tabsContainer: {
      display: 'flex',
      borderBottom: '1px solid #e0e0e0',
      backgroundColor: '#fff',
    },
    tab: {
      padding: '14px 24px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      border: 'none',
      background: 'none',
      color: '#666',
      borderBottom: '3px solid transparent',
      transition: 'all 0.2s ease',
      outline: 'none',
    },
    tabActive: {
      padding: '14px 24px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      border: 'none',
      background: 'none',
      color: '#1976d2',
      borderBottom: '3px solid #1976d2',
      transition: 'all 0.2s ease',
      outline: 'none',
    },
    content: {
      padding: '20px',
    },
    searchRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '16px',
      gap: '16px',
      flexWrap: 'wrap',
    },
    searchInput: {
      padding: '9px 14px',
      border: '1px solid #d0d0d0',
      borderRadius: '6px',
      fontSize: '14px',
      color: '#333',
      outline: 'none',
      width: '300px',
      maxWidth: '100%',
      transition: 'border-color 0.2s ease',
    },
    counter: {
      fontSize: '13px',
      color: '#666',
      fontWeight: '500',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    th: {
      padding: '12px 16px',
      textAlign: 'left',
      fontSize: '12px',
      fontWeight: '600',
      color: '#666',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      borderBottom: '2px solid #e0e0e0',
      backgroundColor: '#fafafa',
    },
    td: {
      padding: '11px 16px',
      fontSize: '14px',
      color: '#333',
      borderBottom: '1px solid #f0f0f0',
    },
    trEven: {
      backgroundColor: '#fafafa',
    },
    trOdd: {
      backgroundColor: '#fff',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '60px 20px',
      color: '#666',
      fontSize: '14px',
    },
    emptyContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '60px 20px',
      color: '#999',
      fontSize: '14px',
    },
    idCell: {
      width: '100px',
      fontWeight: '500',
      color: '#555',
    },
  };

  const renderTable = (data, loading, searchTerm, label) => {
    if (loading) {
      return (
        <div style={styles.loadingContainer}>
          Carregando {label}...
        </div>
      );
    }

    if (data.length === 0) {
      return (
        <div style={styles.emptyContainer}>
          {searchTerm
            ? `Nenhum resultado encontrado para "${searchTerm}"`
            : `Nenhum registro de ${label} encontrado`}
        </div>
      );
    }

    return (
      <div style={{ overflowX: 'auto' }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={{ ...styles.th, ...styles.idCell }}>ID</th>
              <th style={styles.th}>Descrição</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={item.ID}
                style={index % 2 === 0 ? styles.trOdd : styles.trEven}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#e3f2fd'; }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fff' : '#fafafa'; }}
              >
                <td style={{ ...styles.td, ...styles.idCell }}>{item.ID}</td>
                <td style={styles.td}>{item.DESCRICAO || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="data-page" style={styles.container}>
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>🧫</span>
          <div>
            <h1 style={styles.pageTitle}>Materiais e Métodos</h1>
            <p style={styles.pageSubtitle}>Cadastro de materiais e métodos laboratoriais</p>
          </div>
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.tabsContainer}>
          <button
            style={activeTab === 'materiais' ? styles.tabActive : styles.tab}
            onClick={() => setActiveTab('materiais')}
          >
            Materiais
          </button>
          <button
            style={activeTab === 'metodos' ? styles.tabActive : styles.tab}
            onClick={() => setActiveTab('metodos')}
          >
            Métodos
          </button>
        </div>

        <div style={styles.content}>
          {activeTab === 'materiais' && (
            <>
              <div className="responsive-flex" style={styles.searchRow}>
                <input
                  type="text"
                  placeholder="Buscar material por descrição..."
                  value={searchMateriais}
                  onChange={e => setSearchMateriais(e.target.value)}
                  style={styles.searchInput}
                  onFocus={e => { e.target.style.borderColor = '#1976d2'; }}
                  onBlur={e => { e.target.style.borderColor = '#d0d0d0'; }}
                />
                <span style={styles.counter}>
                  {filteredMateriais.length} {filteredMateriais.length === 1 ? 'material encontrado' : 'materiais encontrados'}
                </span>
              </div>
              {renderTable(filteredMateriais, loadingMateriais, searchMateriais, 'materiais')}
            </>
          )}

          {activeTab === 'metodos' && (
            <>
              <div className="responsive-flex" style={styles.searchRow}>
                <input
                  type="text"
                  placeholder="Buscar método por descrição..."
                  value={searchMetodos}
                  onChange={e => setSearchMetodos(e.target.value)}
                  style={styles.searchInput}
                  onFocus={e => { e.target.style.borderColor = '#1976d2'; }}
                  onBlur={e => { e.target.style.borderColor = '#d0d0d0'; }}
                />
                <span style={styles.counter}>
                  {filteredMetodos.length} {filteredMetodos.length === 1 ? 'método encontrado' : 'métodos encontrados'}
                </span>
              </div>
              {renderTable(filteredMetodos, loadingMetodos, searchMetodos, 'métodos')}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MateriaisMetodos;
